import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Sport } from 'src/entities/Sport';
import { SportService } from 'src/services/sport.service';
import {FormGroup, FormControl, Validators, ValidationErrors} from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-edit-sport-modal',
  templateUrl: './edit-sport-modal.component.html',
  styleUrls: ['./edit-sport-modal.component.css'],
})
export class EditSportModalComponent implements OnInit {
  sport: Sport | null = null;
  submitLoading: boolean = false;
  formGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
  });
  errors: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sportService: SportService,
    private dialogRef: MatDialogRef<EditSportModalComponent>
  ) {}

  ngOnInit(): void {
    console.dir(this.data);
    if (this.data.guid) {
      this.sportService
        .getSport(this.data.guid)
        .subscribe((sport: Sport) => {
          this.sport = sport;
          console.log(this.sport);
          this.formGroup.setValue({
            name: sport.name
          });
        });
    } else {
      this.sport = new Sport();
    }
  }

  closeModal(hasBeenChanged: boolean): void {
    this.dialogRef.close({ hasBeenChanged: hasBeenChanged });
  }

  onSubmit(): void {
    this.submitLoading = true;
    this.errors = null;
    let data: any = Object.assign({}, this.formGroup.value);

    if (this.formGroup.valid) {
      // Hardcode data
      data.status = true;
      data.betsapiId = 1;
      data.supplier = '/s/suppliers/2';

      let request: Observable<Sport> = this.data.guid
        ? this.sportService.putSport(this.data.guid, data)
        : this.sportService.createSport(data);

      request
        .subscribe(
          () => {
            this.closeModal(true);
          },
          (response: any) => {
            console.log(response);
            // Show errors
            response.error.violations.forEach((violation: any) => {
              this.formGroup.controls[violation.propertyPath]?.setErrors({
                error: violation.message,
              });
            });
          }
        )
        // Remove loader when all requests are completed
        .add(() => {
          this.submitLoading = false;
        });
    } else {
      Object.keys(this.formGroup.controls).forEach(key => {
        const controlErrors: ValidationErrors = this.formGroup.get(key)?.errors!;
        if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            this.formGroup.controls[key]?.setErrors({
              error: keyError,
            });
          });
        }
      });
    }
  }
}
